export default "__VITE_ASSET__SHG3Jhr6__"